import './PorQueElegirnos.css';

const razones = [
  'Experiencia operando para grandes empresas, con altos estándares de seguridad.',
  'Puntualidad y cumplimiento garantizado.',
  'Cobertura a nivel nacional.',
  'Flota moderna y mantenimiento preventivo.',
  'Personal capacitado y comprometido.',
  'Monitoreo GPS en tiempo real en cada unidad.',
];

export default function PorQueElegirnos() {
  return (
    <section className="pqe">
      <div className="container pqe__inner">
        <div className="pqe__text">
          <h2 className="section-title" style={{ textAlign: 'left' }}>
            ¿Por qué elegirnos?
          </h2>
          <div className="section-divider" style={{ margin: '12px 0 36px' }} />
          <ul className="pqe__list">
            {razones.map((r, i) => (
              <li key={i} className="pqe__item">
                <span className="pqe__check">✓</span>
                <span>{r}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="pqe__banner">
          <p className="pqe__banner-quote">
            "Transportamos más que carga,<br />transportamos confianza."
          </p>
          <span className="pqe__banner-company">— MECAPISCO S.A.C.</span>
        </div>
      </div>
    </section>
  );
}
